export const ADD_ITEM_TOPIC = 'add_item_topic';
export const CANCEL_MOVEMENT_TOPIC = 'cancel_movement_topic';
export const CHECK_FOR_UPDATE_TOPIC = 'check_for_update_topic';
export const CLOSE_MOVEMENT_TOPIC = 'close_movement_topic';
export const DELETE_MOVEMENT_TOPIC = 'delete_movement_topic'
export const CREATE_COMPLEX_MOVEMENT_FROM_TASK_TOPIC = 'create_complex_movement_from_task_topic';
export const CREATE_MOVEMENT_TOPIC = 'create_movement_topic';
export const CREATE_SIMPLE_MOVEMENT_FROM_TASK_TOPIC = 'create_simple_movement_from_task_topic';
export const RETURN_MOVEMENT_TOPIC = 'return_movement_topic';
export const TURN_OFF_BARCODE_READER_TOPIC = 'turn_off_barcode_reader_topic';
export const TURN_ON_BARCODE_READER_TOPIC = 'turn_on_barcode_reader_topic';
export const REJECT_TASK_TOPIC = 'reject_task_topic';
export const START_TASK_TOPIC = 'start_task_topic';
export const TERMINATE_TASK_TOPIC = 'terminate_task_topic';
export const UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC = 'update_number_of_highlights_topic'
export const CREATE_SIMPLE_MOVEMENT_TOPIC = 'create_simple_movement_from_task_topic'
export const START_ITEM_TRANSIT_TOPIC = 'start_item_transit_topic'
export const CREATE_CONTAINER_TOPIC = 'create_container_topic'
export const CLOSE_CONTAINER_TOPIC = 'close_container_topic'
export const OPEN_CONTAINER_TOPIC = 'open_container_topic'
export const DELETE_CONTAINER_TOPIC = 'delete_container_topic'
export const ADD_CONTAINER_TOPIC = 'add_container_topic'
export const ADD_ACCESSORY_TOPIC = 'add_accessory_topic'
export const ADD_LOCATION_TOPIC = 'add_location_topic'